/**
 * Legacy lookup types for dynamic dropdown population
 *
 * LEGACY: Should be removed once recipes migrate to predefined dropdown values
 */
export enum Lookup {
  RawMaterialCompounding = 'substrate_CMP',
  RawMaterialTransport = 'substrate_CVT',
  RawMaterialFloatingZone = 'substrate_FZ',
}
